// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__35KO7","footer":"ModalCreateQualiphyProcedure_footer__2XNJa","additionData":"ModalCreateQualiphyProcedure_additionData__BnrJB"};